import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
type Entity = models.EntregaOcurreDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas : Column[] = [
    {title: "Fecha", cell: x => ({data: kea.toDate(x.Fecha) })},
    {title: "Usuario", cell: x => ({data: x.NombreUsuario })},
    {title: "Cliente", cell: x => ({data: x.NombreCliente })},
    {title: "Contacto", cell: x => ({data: x.NombreContactoCliente })},
    {title: "Cant. guias", cell: x => ({data: x.CantGuias })},
    {title: "Cant. acuses internos", cell: x => ({data: x.CantAcusesInternos })},
    {title: "Sucursal", cell: x => ({data: x.NombreSucursal })},
];

export interface BotonesDeps {
    onVer: (x: Entity) => void;
    onImprimirAcuses: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps) : Column[] {
    const botones = kea.columnaBotones([
        {
            iconClass: fa("print"),
            tooltip: "Imprimir acuses internos",
            onClick: deps.onImprimirAcuses
        }, {
            iconClass: fa("eye"),
            tooltip: "Ver entrega",
            onClick: deps.onVer
        }
    ]);
    
    return [botones, ... columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/list/columns.tsx